const TREE_CONSTANTS = {
  TREE_NODE: 'ccfk-tree-node',
  TREE_BRANCH: 'ccfk-tree-branch',
  TREE_BRANCH_LIST: 'ccfk-tree-branch-list',
  LIST_CONTEXT_MENU_ITEM: 'ccfk-context-menu-tabable',
};

export default TREE_CONSTANTS;